import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';

import { GapView } from './GapView';

export const GapNode = Node.create({
  name: 'gap',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      description: {
        default: '',
        parseHTML: (element: HTMLElement) => element.getAttribute('data-description'),
        renderHTML: (attributes: Record<string, unknown>) => ({
          'data-description': attributes.description,
        }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-type="gap"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes({ 'data-type': 'gap' }, HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(GapView);
  },
});
